module.exports = __webpack_public_path__ + "static/media/audio.52d969d2.png";